import '@/assets/styles/app.scss';

import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store/index';
import { CreateElement } from 'vue/types/umd';
import { i18n } from '@/localization';
import '@/registerServiceWorker';
import '@/layouts/index';

// @ts-ignore
import VueLodash from 'vue-lodash';
// @ts-ignore
import lodash from 'lodash';
// @ts-ignore
Vue.use(VueLodash, { lodash });

// @ts-ignore
import vSelect from 'vue-select';

Vue.component('v-select', vSelect);

// @ts-ignore
import vueMoment from 'vue-moment';
Vue.use(vueMoment);

// @ts-ignore
import VueContentPlaceholders from 'vue-content-placeholders';
Vue.use(VueContentPlaceholders);

// @ts-ignore
import VueFlags from '@growthbunker/vueflags';
Vue.use(VueFlags, { iconPath: '/flags/' });

Vue.config.productionTip = false;

// @ts-ignore
import { ClientTable } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bootstrap4');

import fullCalendar from 'vue-fullcalendar'
Vue.component('full-calendar', fullCalendar);

new Vue({
  router,
  store,
  i18n,
  render: (h: CreateElement) => h(App),
  mounted() {
    this.init();
    const self = this;
    window.addEventListener('resize', () => self.init());
    window.addEventListener('orientationchange', () => self.init());
  },

  methods: {
    init() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
  },
}).$mount('#app');
